import { render, staticRenderFns } from "./activitylist.vue?vue&type=template&id=208ed071&scoped=true&"
import script from "./activitylist.vue?vue&type=script&lang=js&"
export * from "./activitylist.vue?vue&type=script&lang=js&"
import style0 from "./activitylist.vue?vue&type=style&index=0&id=208ed071&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ed071",
  null
  
)

export default component.exports